"use client"

import { ErrorBoundaryUI } from "@/components/error-boundary-ui"

export default function ErrorBoundary({
  error,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  return <ErrorBoundaryUI error={error} />
}
